import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { colors } from '../../../../../../../colorVars';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import NumberInputWithUnitDropdown from '../../../../../../atomic/inputs/numberInputWithUnitDropdown/NumberInputWIthUnitDropdown';
import { ATRTrailDocumentation } from '../../../../documentation/ATRTrailDocumentation';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
const timeUnits = [
  {
    text: 'Min.',
    value: 'MINUTES',
  },
  {
    text: 'Day',
    value: 'DAYS',
  },
  {
    text: 'Week',
    value: 'WEEKS',
  },
  {
    text: 'Month',
    value: 'MONTHS',
  },
  {
    text: 'Quarter',
    value: 'QUARTERS',
  },
  {
    text: 'Year',
    value: 'YEARS',
  },
];

export const AtrTrailModule = ({ state }) => {
  const [atrTrail, dispatchAtrTrail, , setAtrTrailEnabled] = state;
  const [candlesBackDisplay, setCandlesBackDisplay] = useState(0);
  const [atrCandleDurationDisplay, setAtrCandleDurationDisplay] = useState(0);
  const [pctOfAtrDisplay, setPctOfAtrDisplay] = useState(0);

  useEffect(() => {
    setAtrTrailEnabled(true);
  }, []);

  useEffect(() => {
    setCandlesBackDisplay(atrTrail.ATR.candlesBack ?? 0);
    setAtrCandleDurationDisplay(atrTrail.ATR.candleDuration ?? 0);
    setPctOfAtrDisplay(Number(atrTrail.pctOfAtr) * 100 ?? 0);
  }, [atrTrail]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={ATRTrailDocumentation} /> ATR Trail
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>% of ATR</p>
          <NumberInputWithUnit
            backgroundColor={colors.white}
            direction="right"
            type="number"
            value={pctOfAtrDisplay}
            setValue={setPctOfAtrDisplay}
            onBlur={(value) =>
              dispatchAtrTrail({
                pctOfAtr: Number(value) / 100,
              })
            }
          >
            %
          </NumberInputWithUnit>
        </div>
        <div className={style.inputAndLabel}>
          <p>Candles Back</p>
          <NumberInputWithUnit
            backgroundColor={colors.white}
            direction="left"
            type="number"
            value={candlesBackDisplay}
            setValue={setCandlesBackDisplay}
            onBlur={(value) =>
              dispatchAtrTrail({
                ATR: {
                  ...atrTrail.ATR,
                  candlesBack: value,
                },
              })
            }
          >
            #
          </NumberInputWithUnit>
        </div>
        <div className={style.inputAndLabel}>
          <p>ATR Type</p>
          <select
            value={atrTrail.ATR.atrType}
            onChange={({ target }) =>
              dispatchAtrTrail({
                ATR: {
                  ...atrTrail.ATR,
                  atrType: target.value,
                },
              })
            }
          >
            <option value="WILDER">Wilder</option>
            <option value="SMA">SMA</option>
            <option value="SMA_NO_GAP">SMA No Gap</option>
          </select>
        </div>

        <div className={style.inputAndLabel}>
          <p>ATR Candle Duration</p>
          <NumberInputWithUnitDropdown
            list={timeUnits}
            inputVal={atrCandleDurationDisplay}
            setInputVal={setAtrCandleDurationDisplay}
            selectVal={atrTrail.ATR.timeUnit}
            onBlur={(value) =>
              dispatchAtrTrail({
                ATR: {
                  ...atrTrail.ATR,
                  candleDuration: value,
                },
              })
            }
            setSelectVal={(value) =>
              dispatchAtrTrail({
                ATR: {
                  ...atrTrail.ATR,
                  timeUnit: value,
                },
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

AtrTrailModule.propTypes = {
  state: PropTypes.any,
};
